/* ================================================== */
/* COMPONENTS → Loader
/* ================================================== */

$(document).ready(function() {
	$('body').addClass('loaded');

	$('a[href^="http"]').click(function(event) {
		if (!$(this).is('[target="_blank"]') && !$(this).is('[data-fancybox]') && !$(this).is('[data-fancybox-media]') && !$(this).is('[data-transition="false"]')) {
			event.preventDefault();
			var href = $(this).attr('href');
			$('body')
				.append('<link rel="prerender prefetch" href="' + href + '">')
				.addClass('is-loading');
			setTimeout(function() { window.location.href = href }, 300);
		}
	});
});

// Reload page on Safari back nav
(function() {
	window.onpageshow = function(event) {
		if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent) && event.persisted) window.location.reload();
	};
})();